<template>
  <div>
    <div
      class="flex flex-row border-b"
      :class="{
        'border-grey-800': hasState('dark'),
        'border-grey-200': !hasState('dark'),
      }"
    >
      <span
        v-for="tab in tabs"
        :key="tab"
        class="p-4 margin-b-minus text-sm cursor-pointer gp-styleEditor-tabs"
        :class="{
          'text-red': tabsWithErrors.includes(tab),
          'text-pink border-b-2 border-pink':
            !tabsWithErrors.includes(tab) && tab === selected,
          'text-grey-500':
            !tabsWithErrors.includes(tab) &&
            tab !== selected &&
            hasState('dark'),
          'text-grey-800':
            !tabsWithErrors.includes(tab) &&
            tab !== selected &&
            !hasState('dark'),
        }"
        @click="openTab(tab)"
      >
        {{ tab }}
        <i
          v-if="tabsWithErrors.includes(tab)"
          class="fas fa-exclamation-triangle"
        ></i>
      </span>
    </div>
    <div v-for="tab in tabs" v-show="selected === tab" :key="tab">
      <slot :name="tab"></slot>
    </div>
  </div>
</template>
<script>
import mixins from '../mixins';

export default {
  mixins: [mixins],
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeByDefault: {
      type: String,
      required: false,
    },
    dark: {},
    tabsWithErrors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    tabs() {
      this.selected = this.tabs[0];
    },
  },
  mounted() {
    const tab = this.activeByDefault || this.tabs[0];
    this.openTab(tab);
  },
  methods: {
    openTab(tab) {
      this.selected = tab;
      this.$emit('tab-change', tab);
    },
  },
};
</script>
